module.exports = __webpack_public_path__ + "static/media/emergency_supply.fc306316.jpg";